import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import { routes } from "~/constants";
import { trackHeader as track } from "~/events";

interface Props {
  onClick?: () => void;
}

export const SignUpNavItem: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  const handleClick = (): void => {
    onClick?.();
    track.signUpLink();
  };

  return (
    <Button
      as={Link}
      borderColor={{ base: "th.black", lg: "fg-accent" }}
      borderRadius="10px"
      color={{ base: "th.black", lg: "fg-accent" }}
      onClick={handleClick}
      reloadDocument
      minH="unset"
      mb={{ base: 0, lg: 1 }}
      px={3}
      py={1.5}
      size="th-slim"
      to={routes.signUp}
      variant="th-secondary"
      w="fit-content"
    >
      {t("navigation.join")}
    </Button>
  );
};
